module.exports = __webpack_public_path__ + "static/media/g-4-d.adfd045b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-4-d.jpg
// module id = 1139
// module chunks = 33